  <app-pagetitle id="upper" title="Tableau de bord" ></app-pagetitle>

  <div class="row">
    <div class="col-12">
      <!-- Section de bienvenue -->
      <div class="card card-section container-fluid my-3 py-0" style="background-color: #d8f2dc;">
        <div class="row align-items-center welcome-section">
          <div class="col-md-6 text-center text-md-start px-3">
            <h2 class="fw-bold" style="font-size: 1.5em;">Bienvenue dans votre espace de gestion, Administrateur</h2>
            <p style="font-size: 1.1em;">Gérez efficacement votre coopérative agricole. Suivez les performances, et accédez aux ressources nécessaires pour maximiser les rendements.</p>
          </div>
          <div class="col-md-6 text-center">
            <img src="../../../../../assets/images/fams.png" alt="Illustration de gestion agricole" class="img-fluid" style="max-height: 180px; object-fit: contain;">
          </div>
        </div>
      </div>


      <!-- Section des cartes -->
      <div class="container-fluid">
        <div class="row g-4">
          <!-- Carte des stats détaillées -->
          <div class="col-md-4 stats-card" style="box-shadow: 0 8px 12px rgba(0, 0, 0, 0.1);">
            <div *ngIf="simplePieChart"class="card-body">
                <apx-chart 
                  [series]="simplePieChart.series" 
                  [chart]="simplePieChart.chart" 
                  [labels]="simplePieChart.labels"
                  [legend]="simplePieChart.legend"
                  [colors]="simplePieChart.colors"
                  [responsive]="simplePieChart.responsive">
                </apx-chart>
              
            </div>
          </div>

          <!-- Carte vue d'ensemble -->
            <div class="col-md-6">
              <div class="overview-card py-4 px-3 text-white card-section">
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="fw-bold" style="color: white; font-size: 1.2em;">TOTAL DES COOPÉRATIVES</h4>
                    <h2 class="fw-bold m-0" style="color: white; font-size: 2em;">{{statistique.cooperatives || 0}}</h2>
                  </div>
                  <div class="col-md-6">
                    <h4 class="fw-bold" style="color: white; font-size: 1.2em;">TOTAL DES DEMANDES</h4>
                    <h2 class="fw-bold m-0" style="color: white; font-size: 2em;">{{statistique.demandes || 0}}</h2>
                  </div>
                </div>
            
                <hr class="my-2 text-white">
            
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="fw-bold" style="color: white; font-size: 1.2em;">ADMINISTRATEURS VALIDÉS</h4>
                    <h2 class="fw-bold m-0" style="color: white; font-size: 2em;">{{statistique.admins_valides || 0}}</h2>
                  </div>
                  <div class="col-md-6">
                    <h4 class="fw-bold" style="color: white; font-size: 1.2em;">ADMINISTRATEURS REJETÉS</h4>
                    <h2 class="fw-bold m-0" style="color: white; font-size: 2em;">{{statistique.admins_rejetes || 0}}</h2>
                  </div>
                </div>
            
                <hr class="my-2 text-white">
            
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="fw-bold" style="color: white; font-size: 1.2em;">ADMINISTRATEURS EN ATTENTE</h4>
                    <h2 class="fw-bold m-0" style="color: white; font-size: 2em;">{{statistique.admins_attente || 0}}</h2>
                  </div>
                  <div class="col-md-6">
                    <h4 class="fw-bold" style="color: white; font-size: 1.2em;">TOTAL DES AGENTS</h4>
                    <h2 class="fw-bold m-0" style="color: white; font-size: 2em;">{{statistique.agents || 0}}</h2>
                  </div>
                </div>
            
                <hr class="my-2 text-white">
            
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="fw-bold" style="color: white; font-size: 1.2em;">TOTAL DES HOMMES</h4>
                    <h2 class="fw-bold m-0" style="color: white; font-size: 2em;">
                      {{ (statistique.nbre_hommes || 0) | number:'1.2-2' }}
                    </h2>
                  </div>
                  <div class="col-md-6">
                    <h4 class="fw-bold" style="color: white; font-size: 1.2em;">TOTAL DES FEMMES</h4>
                    <h2 class="fw-bold m-0" style="color: white; font-size: 2em;">
                      {{ (statistique.nbre_femmes || 0) | number:'1.2-2' }}
                    </h2>
                  </div>
                  
                </div>
              </div>
            
          </div>
          
        </div>
      </div>

    </div>
  </div>
